import {
  faArrowLeft,
  faCircleUser,
  faMoon,
  faSignOut,
  faSun,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { Dropdown, Nav, NavItem, NavLink } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";

const KioskNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hideBackButton = location.pathname === "/kiosksapp";
  const [theme, setTheme] = useState<"dark" | "light">("dark");

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") as "dark" | "light" | null;
    if (savedTheme) {
      setTheme(savedTheme);
      document.documentElement.setAttribute("data-theme-mode", savedTheme);
    } else {
      document.documentElement.setAttribute("data-theme-mode", "dark");
    }
  }, []);
  useEffect(() => {
    if (theme) {
      document.documentElement.setAttribute("data-theme-mode", theme);
      localStorage.setItem("theme", theme);
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };


  const handleProfileClick = () => {
    navigate("/kiosksapp/Profile");
  };

  const handleSignOut = () => {
    Cookies.remove("authToken");
    Cookies.remove("organizationId");
    Cookies.remove("user");
    window.location.reload();
    window.location.href = "/kiosksapp/signin";
  };

  return (
    <div style={{ borderBottom: "0.5px solid #8B8C8D80" }} >
      <div className="container d-flex justify-content-between align-items-center py-3" style={{ height: "96px" }} >
        <div>
          {!hideBackButton && (
            <div>
              <button className="uniform-back-btn px-5" onClick={() => navigate(-1)}>
                <FontAwesomeIcon icon={faArrowLeft} size="sm" />
              </button>
            </div>
          )}
        </div>
        <div className="text-center">
          {theme === "dark" ? (
            <img src="/images/Spaceai_kiosk_logo_light.svg" alt="Space AI Logo" height={"32px"} />
          ) : (
            <img src="/images/Spaceai_kiosk_logo.svg" alt="Space AI Logo" height={"32px"} />
          )}
        </div>
        <Nav>
          <div className="d-flex align-items-center">
            <button onClick={toggleTheme} className="bg-transparent border-0 px-4">
              {theme === "dark" ? (
                <FontAwesomeIcon icon={faSun} size="xl" style={{ color: "#DAA520" }} title="light mode" />
              ) : (
                <FontAwesomeIcon icon={faMoon} size="xl" style={{ color: "#DAA520" }} title="dark mode" />
              )}
            </button>
          </div>
          <Dropdown as={NavItem} align={{ lg: "end" }} className="p-2">
            <Dropdown.Toggle as={NavLink} className="text-white fs-3">
              <button className="uniform-back-btn px-4">
                <FontAwesomeIcon icon={faCircleUser} size="xl" />
              </button>
            </Dropdown.Toggle>
            <Dropdown.Menu className="p-3 profile-dropdown">
              <Dropdown.Item className="mt-2 ps-1 fs-5" onClick={handleProfileClick} style={{ color: "#FFFFFF" }}>
                <FontAwesomeIcon icon={faUser} className="me-2" />
                Profile
              </Dropdown.Item>
              {/* <Dropdown.Divider className="mt-2" /> */}
              <Dropdown.Item
                className="ps-1 fs-5"
                style={{ color: "#FFFFFF" }}
                onClick={(e) => {
                  e.preventDefault();
                  handleSignOut();
                }}
              >
                <FontAwesomeIcon icon={faSignOut} className="" style={{ color: "#FFFFFF" }} /> Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Nav>
      </div>
    </div>
  );
};

export default KioskNavbar;
